<!-- eslint-disable max-len -->
<template>
  <div>
    <Card title="Content Purchase">
      <template v-slot:body>
        <div>
          <div class="pb-6 flex justify-between items-center">
            <div class="flex items-center">
              <div class="mr-2">
                <date-range-picker
                  ref="picker"
                  :timePicker="false"
                  :showDropdowns="false"
                  :max-date="maxDate"
                  v-model="dateRange"
                  :opens="'right'"
                  @update="onChangeDate"
                  :auto-apply="true"
                >
                  <template v-slot:input="picker" >
                    From: {{ moment(picker.startDate) }} - To: {{ moment(picker.endDate) }}
                  </template>
                </date-range-picker>
              </div>
            </div>
            <div class="flex gap-[16px]">
              <card-stats
                statSubtitle="Total Purchase"
                :statTitle="`$${parseFloat(total_history).toFixed(2)}`"
              />
            </div>
          </div>
        </div>
        <data-tables-server ref="tableTransaction" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [displayingItem] }" @query-change="onChangeTable" >
          <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom" width="auto">
          </el-table-column>
        </data-tables-server>
      </template>
    </Card>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import moment from 'moment';
import { Button } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card.vue';
import CardStats from '@/components/Layout/CardStats.vue';

const displayingItems = 50;

export default {
  name: 'TransactionHistoryPage',
  data() {
    return {
      isLoading: false,
      utc_offset: Math.floor(moment().utcOffset() / 60),
      data: [],
      total: 0,
      displayingItem: displayingItems,
      titles: [{
        prop: 'customer_name',
        label: 'Customer Name',
      }, {
        prop: 'type_text',
        label: 'Type',
      }, {
        prop: 'item_name',
        label: 'Item',
      }, {
        prop: 'date',
        label: 'Date',
      }, {
        prop: 'total_amount_text',
        label: 'Total Amount',
      }, {
        prop: 'artist_cut_text',
        label: 'Artist Cut',
      }, {
        prop: 'musicverse_cut_text',
        label: 'Musicverse Cut',
      }],
      filter: {
        page: 1,
        per_page: displayingItems,
        q: '',
        sortby: 'id',
        sortorder: 'desc',
        start_date: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
      },
      dateRange: {
        startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      },
      maxDate: moment().format('YYYY-MM-DD'),
    };
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListHistory(this.filter);
  },
  computed: {
    ...mapGetters('TransactionAdminModule', ['list_history', 'total_history']),
  },
  watch: {
    list_history: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (this.list_history.data !== undefined) {
          this.data = this.list_history.data.data.map(purchase => ({ ...purchase,
            total_amount_text: `$${parseFloat(purchase.total_amount_dollar).toFixed(2)}`,
            artist_cut_text: `$${parseFloat(purchase.artist_cut_dollar).toFixed(2)}`,
            musicverse_cut_text: `$${parseFloat(purchase.musicverse_cut_dollar).toFixed(2)}`,
            date: moment(purchase.created_at).format('YYYY-MM-DD HH:mm:ss'),
            type_text: purchase.type == 1 ? 'Song' : 'Album',
          }));
          this.total = this.list_history.data.total;
        }
      },
    },
  },
  methods: {
    ...mapActions('TransactionAdminModule', ['requestListHistory']),
    async search() {
      await this.requestListHistory(this.filterFormatUtc({}));
    },
    moment(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    filterFormatUtc(params){
      const startUtc = moment(this.filter.start_date).utc().format('YYYY-MM-DD HH:mm:ss');
      const endUtc = moment(this.filter.end_date).utc().format('YYYY-MM-DD HH:mm:ss');
      return {
        ...this.filter,
        ...params,
        start_date: startUtc,
        end_date: endUtc,
      }
    },
    async reset() {
      this.$refs.tableTransaction.$refs.elTable.clearSort();
      this.filter = {
        page: 1,
        per_page: this.displayingItem,
        sortby: 'id',
        sortorder: 'desc',
        q: '',
        start_date: '',
        end_date: '',
      };
      this.dateRange = {
        startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      },
      this.search();
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filter = Object.assign(this.filter, { per_page: this.displayingItem, sortorder, sortby, page });
      await this.requestListHistory(this.filterFormatUtc({}));
    },
    async onChangeDate(res) {
      this.filter = { ...this.filter,
        start_date: moment(res.startDate).format('YYYY-MM-DD'),
        end_date: moment(res.endDate).format('YYYY-MM-DD'),
      };
      await this.search();
    },
  },
  components: {
    VueCustomTooltip, DateRangePicker,
    Button,
    Card,
    CardStats,
  },
};
</script>
<style scoped>
.z-1000{
  z-index: 1000;
}
.mx-400{
  max-height: 50%;
  height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/views/TransactionHistory.vue